const EndPoints = {
  MEMBER_INFO: memNo => `/baeminpay/v1/users/${memNo}`,
  UPDATE_MEMBER_INFO: memNo => `/baeminpay/v1/users/${memNo}`,
  UPDATE_PHONE_NUMBER: memNo => `/baeminpay/v1/users/${memNo}/phoneNumber`,
  WITHDRAW: memNo => `/baeminpay/v1/users/${memNo}`,


  ID_VERIFICATION_TOKEN: "/baeminpay/v1/identity",
  REQUEST_ARS: memNo => `/baeminpay/v1/users/${memNo}/ars-verification`,
  CHECK_ARS_STATUS: (memNo, arsVerificationNumber) =>
    `/baeminpay/v1/users/${memNo}/ars-verification/${arsVerificationNumber}`,
  SIGN_UP: "/baeminpay/v1/users",
  SIGN_UP_PROPOSAL: memNo => `/baeminpay/v1/signup/${memNo}/proposal`,

  BIN_CODE_LIST: "/baeminpay/v1/codes/bin",
  FETCH_BIN_CODE: binCode => `/baeminpay/v1/code/bin/${binCode}`,
  CARD_ENCRYPT_POLICY: (financialCode, binCode) =>
    `/baeminpay/v1/field/card-verification/${financialCode}/${binCode}`,
  CARD_VERIFICATION: memNo => `/baeminpay/v1/users/${memNo}/card-verification`,
  ENROLL_CARD: memNo => `/baeminpay/v1/users/${memNo}/pockets/card`,
  ENROLL_BANK: memNo => `/baeminpay/v1/users/${memNo}/pockets/bank`,

  REGISTERED_BANK_LIST: "/baeminpay/v1/codes/bank",
  REGISTERED_CARD_LIST: "/baeminpay/v1/codes/card",
  FETCH_POCKET_LIST: memNo => `/baeminpay/v1/users/${memNo}/pockets`,
  DELETE_POCKET_BY_POCKET_NO: (memNo, pocketNo) =>
    `/baeminpay/v1/users/${memNo}/pockets/${pocketNo}`,
  DELETE_POCKET_BY_FINANCIAL_CODE: (memNo, financialCode) =>
    `/baeminpay/v1/users/${memNo}/financialCode/${financialCode}`,

  VERIFY_PASSWORD: "/baeminpay/v1/password/validation",
  ENROLL_PASSWORD: memNo => `/baeminpay/v1/users/${memNo}/password`,
  GET_PASSWORD_TOKEN: memNo => `/baeminpay/v1/users/${memNo}/password/token`,
  RESET_WITH_ID: memNo => `/baeminpay/v1/users/${memNo}/password`,
  RESET_WITH_PASSWORD: memNo => `/baeminpay/v1/users/${memNo}/password`
}

class StoreProps {
  constructor({
    memberNumber,
    externals = {
      deeplink,
      action,
      INTERNAL_WEB
    },
    logData = {
      env,
      sessionId,
      dvcId,
      screenName
    },
    setAndroidBackHandler
  }) {
    this.memberNumber = memberNumber
    this.endPoints = EndPoints
    this.externals = {
      appscheme: {
        deeplink: externals.deeplink,
        action: externals.action
      },
      INTERNAL_WEB: externals.INTERNAL_WEB
    }
    this.logData = logData
    this.setAndroidBackHandler = setAndroidBackHandler
  }
}

class PaymentMethodSelectionFlowProps {
  constructor({
    selectedCode,
    paymentMethodList,
    selectedBaeminpayPocketNo,
    appVersion,
    guest,
    onSelect,
    onCancel
  }) {
    this.selectedCode = selectedCode
    this.paymentMethodList = paymentMethodList
    this.selectedBaeminpayPocketNo = selectedBaeminpayPocketNo
    this.appVersion = appVersion
    this.guest = guest
    this.onSelect = onSelect
    this.onCancel = onCancel
  }
}

class PaymentMethodSelectionFieldFlowProps {
  constructor({
    selectedCode,
    defaultPaymentMethodCode,
    paymentMethodList,
    selectedBaeminpayPocketNo,
    appVersion,
    guest,
    goLogin,
    onSelect,
    onTogglePopup,
    onCancel
  }) {
    this.selectedCode = selectedCode
    this.defaultPaymentMethodCode = defaultPaymentMethodCode
    this.paymentMethodList = paymentMethodList
    this.selectedBaeminpayPocketNo = selectedBaeminpayPocketNo
    this.appVersion = appVersion
    this.guest = guest
    this.goLogin = goLogin
    this.onSelect = onSelect
    this.onTogglePopup = onTogglePopup
    this.onCancel = onCancel
  }
}

class PaymentMethodResp {
  constructor(value) {
    this.code = value.code
    this.displayName = value.displayName
    this.promotion = value.promotion
    this.availableCashReceipt = value.availableCashReceipt
    this.availableGuest = value.availableGuest
    this.default = value.default
    this.disable = value.disable
    this.disableDescription = value.disableDescription
  }
}

class SelectedPocket {
  constructor({
    code,
    displayName,
    availableCashReceipt,
    baeminpay = {
      pocketName,
      pocketNo
    }
  }) {
    this.code = code
    this.displayName = displayName
    this.availableCashReceipt = availableCashReceipt
    this.baeminpay = baeminpay
  }
}

export {
  StoreProps,
  PaymentMethodSelectionFlowProps,
  PaymentMethodSelectionFieldFlowProps,
  PaymentMethodResp,
  SelectedPocket
}
